import { useCallback, useState } from 'react'

const useCheckboxSelection = (props) => {
  const onlySingle = props?.onlySingle || false
  const [selected, setSelected] = useState([])

  const selectAllClick = useCallback((event, items, attribute) => {
    if (event.target.checked) {
      setSelected(attribute ? items.map((n) => n?.[attribute]) : items)
      return
    }
    setSelected([])
  }, [])

  const selectClick = (value, attribute) => {
    if (onlySingle) {
      setSelected([value])
    } else {
      setSelected((prevSelected) => {
        const selectedIndex = attribute
          ? prevSelected.findIndex(
              (item) => item?.[attribute] === value?.[attribute]
            )
          : prevSelected.indexOf(value)
        let newSelected = []

        if (selectedIndex === -1) {
          newSelected = newSelected.concat(prevSelected, value)
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(prevSelected.slice(1))
        } else if (selectedIndex === prevSelected.length - 1) {
          newSelected = newSelected.concat(prevSelected.slice(0, -1))
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
            prevSelected.slice(0, selectedIndex),
            prevSelected.slice(selectedIndex + 1)
          )
        }

        return newSelected
      })
    }
  }

  const resetSelected = useCallback(() => setSelected([]), [])

  const isSelected = useCallback(
    (value, attribute) =>
      attribute
        ? selected.findIndex(
            (item) => item?.[attribute] === value?.[attribute]
          ) !== -1
        : selected.indexOf(value) !== -1,
    [selected]
  )

  return {
    selected,
    selectAllClick,
    selectClick,
    isSelected,
    resetSelected,
  }
}

export default useCheckboxSelection
